'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles');

var _NitroFormatter = require('../nitro-formatter/NitroFormatter');

var _NitroFormatter2 = _interopRequireDefault(_NitroFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NitroDefinition = function NitroDefinition(_ref) {
  var className = _ref.className,
      data = _ref.data,
      rowspacing = _ref.rowspacing,
      otherProps = _objectWithoutProperties(_ref, ['className', 'data', 'rowspacing']);

  var getDescription = function getDescription(item) {
    if (item.valueComponent) return item.valueComponent;

    if (item.description) {
      if (item.type && item.type === 'email') {} else if (item.type && item.type === 'tel') {} else if (item.type && item.type === 'skype') {} else if (item.type && item.type === 'currency') {}

      if (item.type) {
        var ref = '';
        switch (item.type) {
          case 'email':
            ref = 'mailto:' + item.description;
            return _react2.default.createElement(
              'a',
              { href: ref },
              item.description
            );
          case 'tel':
            ref = 'tel:' + item.description;
            return _react2.default.createElement(
              'a',
              { href: ref },
              item.description
            );
          case 'skype':
            ref = 'callto:' + item.description;
            return _react2.default.createElement(
              'a',
              { href: ref },
              item.description
            );
          case 'intcurrency':
          case 'integer':
          case 'currency':
          case 'date':
            return _react2.default.createElement(_NitroFormatter2.default, { otherProps: true, data: item.description, type: item.type });
        }
      }

      return item.description;
    }

    return '-';
  };

  if (!data) {
    return null;
  }

  var definitions = data.map(function (item, index) {
    return _react2.default.createElement(
      _styles.Definition,
      { key: index, rowspacing: rowspacing },
      _react2.default.createElement(
        _styles.Title,
        null,
        item.title
      ),
      _react2.default.createElement(
        _styles.Description,
        null,
        getDescription(item)
      )
    );
  });

  return _react2.default.createElement(
    _styles.Definitions,
    { className: className },
    definitions
  );
};

NitroDefinition.propTypes = {
  data: _propTypes2.default.array.isRequired,
  layout: _propTypes2.default.string,
  className: _propTypes2.default.string,
  rowspacing: _propTypes2.default.number
};

NitroDefinition.defaultProps = {
  rowspacing: 4
};

exports.default = NitroDefinition;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-definition/NitroDefinition.js
// module id = 2901
// module chunks = 4